import { render, staticRenderFns } from "./companySummary.vue?vue&type=template&id=fc52d1be"
import script from "./companySummary.vue?vue&type=script&lang=js"
export * from "./companySummary.vue?vue&type=script&lang=js"
import style0 from "./companySummary.vue?vue&type=style&index=0&id=fc52d1be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports